import { CircularProgress } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

/**
 * LoadingSpinner component with flexible placement options
 * @param {number} size - Size of the spinner (default: 24)
 * @param {string} color - Color of the spinner (default: "#212A42")
 * @param {string} placement - Placement style for the spinner
 *   - 'centered': Full container centered (default)
 *   - 'default': Inline, no special positioning
 *   - 'overlay': Fixed position overlay covering entire screen
 *   - 'relative': Centered within parent container
 *   - 'inline-start': Inline at the start (left-aligned)
 *   - 'inline-end': Inline at the end (right-aligned)
 * @param {string} overlayColor - Background color for overlay placement (default: "rgba(255, 255, 255, 0.8)")
 */
const LoadingSpinner = ({ 
  size = 24, 
  color = "#212A42", 
  placement = "centered",
  overlayColor = "rgba(255, 255, 255, 0.8)"
}) => {
  
  const getContainerStyle = () => {
    switch (placement) {
      case 'default':
        return {
          display: 'inline-block'
        };
      
      case 'overlay':
        return {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: overlayColor,
          zIndex: 9999
        };
      
      case 'relative':
        return {
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%'
        };
      
      case 'inline-start':
        return {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center'
        };
      
      case 'inline-end':
        return {
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        };
      
      case 'centered':
      default:
        return {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        };
    }
  };

  return (
    <div style={getContainerStyle()}>
      <CircularProgress size={size} style={{ color }} />
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  placement: PropTypes.oneOf([
    'centered',
    'default', 
    'overlay',
    'relative',
    'inline-start',
    'inline-end'
  ]),
  overlayColor: PropTypes.string
};

export default LoadingSpinner;
